import CryptoJS from 'crypto-js';

// Ideally, store this key in your .env file as VUE_APP_SECRET_KEY
const SECRET_KEY = "celata-piyestra-secret-key-2026";

export const encryptData = (data) => {
    if (data === null || data === undefined) return null;
    // Convert object to string, then encrypt
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

export const decryptData = (ciphertext) => {
    if (!ciphertext) return null;
    try {
        const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedData);
    } catch (e) {
        console.error("Decryption failed", e);
        return null;
    }
};
